import stat1 from '../../../../assets/AMR_3534GREG.jpeg'
import stat2 from '../../../../assets/AMR_3697GREG.jpeg'
import stat3 from '../../../../assets/BABE0327GREG.jpeg'
import stat4 from '../../../../assets/BABE0627GREG.jpeg'
import iconSearch from '../../../../assets/icon-search.webp'
import iconExplora from '../../../../assets/icon-explora.webp'
import iconLang from '../../../../assets/icon-lang.webp'
import logoIb from '../../../../assets/logo-ib-494x485.png'
import "./stats.scss"

import { useMediaQuery } from 'react-responsive';
import ReactMarkdown from 'react-markdown';
import { Link } from 'react-router-dom';
import { useState } from "react";

const DeviceSize = {
  mobile: 780,
  tablet: 992,
  laptop: 1324,
  desktop: 2024,
};

const stats = [
  {
    icon: iconSearch,
    title: "Visión",
    type: "title",
    img: stat1,
    iconSize: "3rem",
    link: "/conocenos/filosofia",
    description: `Ser una institución de referencia en el sistema educativo por ofrecer y promover una educación de calidad con un modelo innovador enfocado en el desarrollo de competencias para la vida.`
  },
  {
    icon: logoIb,
    type: "title",
    title: "Bachillerato Internacional",
    img: stat2,
    iconSize: "3rem",
    link: "/curriculum/bachillerato-ib",
    description: `Desde el 2017 ofrecemos el reconocido Programa del Diploma del Bachillerato Internacional (IB), una formación de dos años con proyección global, ideal para estudiantes que buscan acceder a universidades en cualquier parte del mundo.`
  },
  {
    icon: iconLang,
    title: "Idiomas",
    type: "title",
    img: stat3,
    iconSize: "3rem",
    link: "/curriculum?seccion=actividades-interdisciplinarias",
    description: `Nuestros estudiantes alcanzan un dominio del inglés nivel B2 (MCER), con opción a certificación internacional a través de los exámenes de Cambridge.
    Asimismo, el francés presente en todos los niveles, con posibilidad de certificación internacional a través del DELF, avalado por el Ministerio de Educación de Francia.`
  },
  {
    icon: iconExplora,
    title: "Explora+",
    type: "title",
    img: stat4,
    iconSize: "3rem",
    link: "/curriculum?seccion=actividades-interdisciplinarias",
    description: `Nuestro programa de actividades vespertinas, diseñado para impulsar el desarrollo integral en un ambiente dinámico y personalizado.

+30 talleres, clubes y clases en modalidad presencial y virtual, que permiten a los estudiantes descubrir su pasión y desarrollar sus talentos.`
  },
]

export default function Stats(props) {
  const isMobile = useMediaQuery({ maxWidth: DeviceSize.mobile });
  return isMobile ? (<StatsAccordion stats={stats} />) : (
    <section className='stats-container'>
      {
        stats.map((stat) => <Stat key={stat.title} stat={stat} />)
      }
    </section>
  )
}

function Stat(props) {
  const { icon, description, title, link } = props.stat
  const isLang = title === "Idiomas";

  return (
    <article className='stats-item'>
      <div className='stat_header'>
        {icon && (
          <div className='stat_header-icon-wrapper'>
            <img
              className={`stat_header-icon ${isLang ? 'stat_header-icon--lang' : ''}`}
              src={icon}
              alt={`Ícono de ${title}`}
            />
          </div>
        )}
        <h3 className='stat_header-title'>{title}</h3>
      </div>
      <div className='stat_body'>
        <ReactMarkdown skipHtml={false}>{description}</ReactMarkdown>
      </div>
      {link && (
        <div className='stat_action'>
          <Link to={link} className='stat_btn'>
            <span>Conoce más</span>
            <span className='stat_btn-arrow'>→</span>
          </Link>
        </div>
      )}
    </article>
  )
}

export function StatsAccordion({ stats }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="stats-accordion">
      {stats.map((stat, index) => (
        <div key={index} className="accordion-item">
          <button className="accordion-header" onClick={() => toggle(index)}>
            <article value={stat.value} type={stat.type} style={{
              background: `
                  linear-gradient(-45deg, rgba(10, 65, 93, 0.53), rgba(10,65,93, 1)),
                  url(${stat.img}) no-repeat center/cover
                `,
            }}>
              <span>{stat.title}</span>
              <span>{stat.description.slice(0, 30)}...</span>
            </article>
          </button>
          {openIndex === index && (
            <div
              className="accordion-body"
              style={{
                background: `
                  linear-gradient(-45deg, rgba(10, 65, 93, 0.53), rgba(10,65,93, 1)),
                  url(${stat.img}) no-repeat center/cover
                `,
              }}
            >
              <p>{stat.description}</p>
              {stat.link && (
                <div className="accordion-action">
                  <Link to={stat.link} className="stat_btn">
                    Conoce más
                  </Link>
                </div>
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
}
